import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useCallback, useRef } from "react";
import { DeleteEnquiry, GetAllEnquiry } from "../../src/reducer/EnquirySlice";
import { todayDateInput } from "../utils/dateInput";
import { GetAllCountries2 } from "../reducer/Countries";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { EnquiryStatus } from "../../src/reducer/EnquirySlice";
import MenuItem from "@mui/material/MenuItem";
import { ImportEnquirys } from "../../src/reducer/EnquirySlice";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentIcon from "@mui/icons-material/Assignment";
import axios from "axios";
import { AdminBaseUrl, baseurl } from "../Basurl/Baseurl";
import { formatTime12Hour } from "../utils/appointmentHelpers";
import { Autocomplete, OutlinedInput, Pagination, Stack } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { usePDF } from "react-to-pdf";
import { GetAllHositalData } from "../reducer/HospitalSlice";
import { Field } from "formik";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import { testForms } from "../reducer/FormsEnquiry";
import {
  SOS_STATUS_OPTIONS,
  formatEmergencyContacts,
  formatSosDisplayValue,
  getSosItemKey,
  getSosPatientPhone,
  normalizeSosData,
} from "../utils/sosHelpers";
import {
  SOS_EMERGENCY_PERMISSION,
  CAMPAIGN_CONTACTS_PERMISSION,
  CHATBOT_LEADS_PERMISSION,
  ENQUIRY_SUB_TAB_PERMISSIONS,
  hasEnquirySubTabPermission,
  hasDoctorReviewPermission,
  openSosAlertFromListing,
} from "../utils/sosPermissions";
import { useKeyedSubmitLock } from "../hooks/useSubmitLock";
import {
  connectSosSocket,
  onSosAlertDismissed,
  onSosWebAlert,
} from "../services/sosSocket";
import {
  fetchCampaignContacts,
  fetchChatbotLeads,
} from "../services/leadsApi";
import { canStaffDelete, canStaffEdit, canStaffExport } from "../utils/staffActions";

const SOS_LIST_POLL_MS = 10000;

const truncateCellText = (text, maxLength = 15) => {
  if (!text) return "";
  const value = String(text);
  return value.length > maxLength
    ? `${value.substring(0, maxLength)}...`
    : value;
};

export default function Inquiry() {
  const { toPDF, targetRef } = usePDF({ filename: "inquiry.pdf" });
  const role = localStorage.getItem("Role");
  const isReferral = (role || "").toUpperCase() === "REFERRAL";
  const allowEdit = isReferral || canStaffEdit();
  const allowDelete = canStaffDelete();
  const allowExport = isReferral || canStaffExport();
  const navigate = useNavigate();
  const [note, setNote] = useState("");
  const [date, setDate] = useState();
  const [datauserId, setDatauserId] = useState([]);
  const [open2, setOpen2] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open9, setOpen9] = React.useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [tratmentenqId, setTratmentenqId] = useState("");
  const [page, setPage] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [orderDirection, setOrderDirection] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [Title, setTitle] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [report, setReport] = useState([]);
  const [searchApiData, setSearchApiData] = useState([]);
  const [hospitalList, setHospitalList] = useState([]);
  const [roleStatuses, setRoleStatuses] = useState([]);
  const [getcountries, setGetcountries] = useState([]);
  const dispatch = useDispatch();
  const { testForms: formData } = useSelector((state) => state.testForms);
  const { Enquiry, loading, error } = useSelector((state) => state.Enquiry);
  const { hospital } = useSelector((state) => state.hospital);
  const { Countries } = useSelector((state) => state.Countries);
  const [tabValue, setTabValue] = useState(0);
  const [enquiryFilter, setEnquiryFilter] = useState({
    country: "",
    treatingIn: "",
    status: "",
  });
  const [recommend, setRecommend] = useState("");
  const [images, setImages] = useState([]);
  const [airAmbulanceData, setAirAmbulanceData] = useState([]);
  const [ambulanceData, setAmbulanceData] = useState([]);
  const [hospitlID, setHospitlID] = useState([]);
  const [openAppointment, setOpenAppointment] = useState(false);
  const [appointmentData, setAppointmentData] = useState({
    hospital_id: "",
    hospitalName: "",
    health_issue: "",
    Notes: "",
    appointment_Date: "",
    appointment_Time: "",
    enq_userName: "",
    user_id: "",
    enq_phoneNumber: "",
    enq_email: "",
    enquiryId: "",
  });
  const [treatmentData, setTreatmentData] = useState([]);
  const [sosData, setSosData] = useState([]);
  const [sosLoading, setSosLoading] = useState(false);
  const [socialMediaData, setSocialMediaData] = useState([]);
  const [chatbotLeadsData, setChatbotLeadsData] = useState([]);
  const [socialMediaLoading, setSocialMediaLoading] = useState(false);
  const [chatbotLeadsLoading, setChatbotLeadsLoading] = useState(false);
  const [socialMediaPage, setSocialMediaPage] = useState(1);
  const [chatbotLeadsPage, setChatbotLeadsPage] = useState(1);
  const [socialMediaTotalPages, setSocialMediaTotalPages] = useState(1);
  const [chatbotLeadsTotalPages, setChatbotLeadsTotalPages] = useState(1);
  const [leadDetailOpen, setLeadDetailOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const { busyKey, run: runSubmit } = useKeyedSubmitLock();
  useEffect(() => {
    dispatch(testForms());
  }, [dispatch]);
  useEffect(() => {
    getUserId();
  }, []);
  useEffect(() => {
    setHospitalFunction();
  }, []);
  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };
  const permissions = localStorage.getItem("permissionArray") || "";
  const canDoctorReview = hasDoctorReviewPermission(permissions, role);
  console.log(permissions);
  const handleRecommendTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleRecommendChange = (e) => {
    setRecommend(e.target.value);
  };
  const tabsConfig = [
    { label: "Enquiry", value: 0, permission: "/Enquiries" },
    { label: "Ambulance Service", value: 1, permission: "/Ambulance_Service" },
    {
      label: "Air Medical Escort",
      value: 2,
      permission: "/Air_Medical_Escort",
    },
    {
      label: "Treatment Estimate",
      value: 3,
      permission: "/Treatment_Estimate",
    },
    {
      label: "Emergency SOS",
      value: 4,
      permission: SOS_EMERGENCY_PERMISSION,
    },
    // {
    //   label: "CAMPAIGN CONTACTS",
    //   value: 5,
    //   permission: CAMPAIGN_CONTACTS_PERMISSION,
    // },
    // {
    //   label: "CHATBOT LEADS",
    //   value: 6,
    //   permission: CHATBOT_LEADS_PERMISSION,
    // },
  ];
  const isLeadTab = tabValue === 5 || tabValue === 6;
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };
  const filteredTabs = tabsConfig.filter((tab) =>
    ENQUIRY_SUB_TAB_PERMISSIONS.includes(tab.permission)
      ? hasEnquirySubTabPermission(permissions, tab.permission, role)
      : permissions.includes(tab.permission),
  );
  const handleNotesdataqw = async (e) => {
    e.preventDefault();
    if (!Title || !note || !recommend) {
      return Swal.fire("Error", "All fields are required", "error");
    }

    await runSubmit("review", async () => {
      try {
        let response;
        if (tabValue === 0) {
          const enquiryPayload = new FormData();
          enquiryPayload.append("title", Title); // <-- Add this
          enquiryPayload.append("review_notes", note);
          enquiryPayload.append("Recommendations", recommend); // ⚠️ old API key
          enquiryPayload.append("enquiryId", enqId);
          enquiryPayload.append("user_type", statusRole);
          images.forEach((img) => {
            enquiryPayload.append("images", img);
          });
          console.log("OLD API PAYLOAD →", [...enquiryPayload.entries()]);
          response = await axios.post(
            `${baseurl}addDoctorReview`,
            enquiryPayload,
          );
        } else {
          const newPayload = new FormData();
          const typeMap = {
            1: "AmbulanceRequest",
            2: "AirAmbulance",
            3: "PatientQuery",
          };
          newPayload.append("review_notes", note);
          newPayload.append("enquiry_id", tratmentenqId);
          newPayload.append("recommendations", recommend);
          newPayload.append("title", Title);
          newPayload.append("user_type", statusRole);
          newPayload.append("reference_id", enqId);
          newPayload.append("model_type", typeMap[tabValue]);
          images.forEach((img) => {
            newPayload.append("images[]", img);
          });
          console.log("NEW API PAYLOAD →", [...newPayload.entries()]);
          response = await axios.post(`${AdminBaseUrl}review/store`, newPayload);
        }
        if (response?.data?.success) {
          handleClose4();
          Swal.fire("Success", "Doctor Review Added Successfully", "success");
          setTitle(""); // <-- Clear title
          setNote("");
          setRecommend("");
          setImages([]);
        }
      } catch (error) {
        console.log(error);

        let message = "Something went wrong";

        if (error.response) {
          message = error.response.data?.message || message;
        } else if (error.request) {
          message = "No response from server";
        } else {
          message = error.message;
        }
        Swal.fire("Error", message, "error");
      }
    });
  };
  const statusRole = localStorage.getItem("Role");
  const get3tabdata = async (datauserId, getcountry, rolestatus) => {
    const payload = {
      user_ids: datauserId,
      accessCountries: getcountry,
      roleStatuses: rolestatus,
      is_admin: statusRole === "Admin" ? 1 : 0,
    };
    try {
      const response = await axios.post(
        `${AdminBaseUrl}other_enquiry_requests`,
        payload,
      );
      console.log(response.data.data);
      setAirAmbulanceData(response.data?.data?.air_ambulance || []);
      setAmbulanceData(response?.data?.data?.ambulance_requests || []);
      setTreatmentData(response?.data?.data?.get_treatment_estimate || []);
    } catch (error) {
      console.log(error);
    }
  };
  const getSosList = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setSosLoading(true);
    try {
      const response = await axios.get(`${baseurl}sos/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const apiData = response.data?.data || [];
      if (response.data?.success && Array.isArray(apiData)) {
        setSosData(apiData);
      } else if (Array.isArray(apiData)) {
        setSosData(apiData);
      } else {
        setSosData([]);
      }
    } catch (error) {
      console.log(error);
      if (!silent) setSosData([]);
    } finally {
      if (!silent) setSosLoading(false);
    }
  }, []);

  const getSocialMediaList = useCallback(async (pageNum = 1) => {
    setSocialMediaLoading(true);
    try {
      const result = await fetchCampaignContacts({
        page: pageNum,
        limit: rowsPerPage,
      });
      setSocialMediaData(result.data || []);
      setSocialMediaTotalPages(result.lastPage || 1);
      setSocialMediaPage(result.currentPage || pageNum);
    } catch (error) {
      console.log(error);
      setSocialMediaData([]);
      setSocialMediaTotalPages(1);
      toast.error(
        error?.response?.data?.message || "Failed to load Campaign Contacts",
      );
    } finally {
      setSocialMediaLoading(false);
    }
  }, [rowsPerPage]);

  const getChatbotLeadsList = useCallback(async (pageNum = 1) => {
    setChatbotLeadsLoading(true);
    try {
      const result = await fetchChatbotLeads({
        page: pageNum,
        limit: rowsPerPage,
      });
      setChatbotLeadsData(result.data || []);
      setChatbotLeadsTotalPages(result.lastPage || 1);
      setChatbotLeadsPage(result.currentPage || pageNum);
    } catch (error) {
      console.log(error);
      setChatbotLeadsData([]);
      setChatbotLeadsTotalPages(1);
      toast.error(
        error?.response?.data?.message || "Failed to load Chatbot Leads",
      );
    } finally {
      setChatbotLeadsLoading(false);
    }
  }, [rowsPerPage]);

  const getSosListRef = useRef(getSosList);
  getSosListRef.current = getSosList;
  const getPatientPhone = (info) => getSosPatientPhone(info);
  const handleAcceptSos = async (info) => {
    const result = await Swal.fire({
      title: "Accept Case?",
      text: `Accept SOS case for ${info.name}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Accept",
    });
    if (!result.isConfirmed) return;
    const sosId = info.sosId || info.id;
    try {
      const res = await axios.put(
        `${baseurl}sos/${sosId}/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (res?.data?.success !== false) {
        Swal.fire("Success", "Case accepted successfully", "success");
        getSosList();
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Failed to accept SOS case",
        "error",
      );
    }
  };
  const postSosListAction = async (sosId, type) => {
    return axios.post(
      `${baseurl}sos/${sosId}/action`,
      { type },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
  };
  const handleCallPatient = async (info) => {
    const phone = getPatientPhone(info);
    if (!phone) {
      return Swal.fire("Error", "Patient phone number not available", "error");
    }
    window.location.href = `tel:${phone}`;
    try {
      await postSosListAction(info.sosId || info.id, "Call");
    } catch (error) {
      console.log(error);
    }
  };
  const handleWhatsAppPatient = async (info) => {
    const phone = getPatientPhone(info).replace(/\+/g, "");
    if (!phone) {
      return Swal.fire("Error", "Patient phone number not available", "error");
    }
    window.open(`https://wa.me/${phone}`, "_blank");
    try {
      await postSosListAction(info.sosId || info.id, "WhatsApp");
    } catch (error) {
      console.log(error);
    }
  };
  const handleDispatchAmbulance = async (info) => {
    const sosId = info.sosId || info.id;
    try {
      await postSosListAction(sosId, "DispatchAmbulance");
      Swal.fire({
        title: "Ambulance Dispatched",
        text: `Ambulance dispatch logged for ${info.name}.`,
        icon: "success",
      });
      getSosList();
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Failed to dispatch ambulance",
        "error",
      );
    }
  };
  const handleArrangeAirAmbulance = async (info) => {
    const sosId = info.sosId || info.id;
    try {
      await postSosListAction(sosId, "AirAmbulance");
      Swal.fire({
        title: "Air Ambulance Arranged",
        text: `Air ambulance arrangement logged for ${info.name}.`,
        icon: "success",
      });
      getSosList();
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Failed to arrange air ambulance",
        "error",
      );
    }
  };
  const ViewSosDetail = (e, info) => {
    localStorage.setItem("tabenquiry", 4);
    navigate("/Admin/SOS-Detail", {
      state: {
        id: info.sosId || info.id,
        data: info.raw || info,
      },
    });
  };
  const OpenSosAlertModal = (e, info) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const sosId = info?.sosId || info?.id;
    if (!sosId) return;
    openSosAlertFromListing(sosId, {
      type: "SOS_REOPEN_FROM_LIST",
      sosId,
      emergencyCaseId: info.emergencyCaseId,
      patientName: info.name,
      status: info.status,
      title: "SOS ALERT",
      body: `${info.name || "Patient"} — Emergency case from listing`,
      ...(info.raw || info),
    });
  };
  const handleSosStatusChange = async (e, info) => {
    const status = e.target.value;
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Update SOS status to ${status}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!result.isConfirmed) return;
    const sosId = info.sosId || info.id;
    const itemKey = getSosItemKey(info);

    // Prefer dedicated close endpoint when closing
    if (String(status).toLowerCase() === "closed") {
      try {
        await axios.put(
          `${baseurl}sos/${sosId}/close`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        setSosData((prev) =>
          prev.map((item) =>
            getSosItemKey(item) === itemKey ? { ...item, status } : item,
          ),
        );
        setSosStatus((prev) => ({ ...prev, [itemKey]: status }));
        return;
      } catch (error) {
        Swal.fire(
          "Error",
          error?.response?.data?.message || "Failed to close SOS",
          "error",
        );
        return;
      }
    }

    try {
      const response = await axios.post(
        `${baseurl}sos/update_status`,
        { sosId, status },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        setSosData((prev) =>
          prev.map((item) =>
            getSosItemKey(item) === itemKey ? { ...item, status } : item,
          ),
        );
        setSosStatus((prev) => ({ ...prev, [itemKey]: status }));
      }
    } catch (error) {
      setSosData((prev) =>
        prev.map((item) =>
          getSosItemKey(item) === itemKey ? { ...item, status } : item,
        ),
      );
      setSosStatus((prev) => ({ ...prev, [itemKey]: status }));
    }
  };
  useEffect(() => {
    dispatch(GetAllHositalData());
    console.log(error, hospital);
  }, [dispatch]);
  const [seekerStatus, setSeekerStatus] = React.useState({});
  const [sosStatus, setSosStatus] = React.useState({});
  const [blogErr, setBlogErr] = useState(false);
  const [pdfRowLimit, setPdfRowLimit] = useState(false);
  console.log(Enquiry);
  const [enqId, setEnqId] = useState("");
  const handleClose3 = () => {
    setOpen3(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClose4 = () => {
    setOpen4(false);
  };
  const handleClose2wew = () => {
    setOpen9(false);
  };
  const handleClickOpen2modla = () => {
    setOpen9(true);
  };
  const handleClickOpen2 = (e, enq) => {
    setOpen2(true);
    setEnqId(enq);
  };
  const handleClickOpen4 = (e, enq, info) => {
    console.log(info);
    setOpen4(true);
    setEnqId(enq);
    setTratmentenqId(info.id);
  };
  const handleClickOpen3 = (e) => {
    setOpen3(true);
  };
  const statusMap = {
    0: "Pending",
    1: "Confirmed",
    2: "Hold",
    3: "Follow-Up",
    4: "Dead",
    5: "1 Visit",
    6: "2 Visit",
    7: "Visa",
  };

  const getEnquiryStatusValue = (enquiryStatus) => {
    if (enquiryStatus === "Hold") return "2";
    if (enquiryStatus === "Follow-Up") return "3";
    if (enquiryStatus === "Dead") return "4";
    if (enquiryStatus === "1 Visit" || enquiryStatus === "Visit 1") return "5";
    if (enquiryStatus === "2 Visit" || enquiryStatus === "Visit 2") return "6";
    if (enquiryStatus === "Visa") return "7";
    return "0";
  };
  useEffect(() => {
    dispatch(GetAllEnquiry());
    dispatch(GetAllCountries2());
    console.log(error, Enquiry);
  }, [dispatch]);

  const handleEnquiryFilterChange = (event) => {
    const { name, value } = event.target;
    setEnquiryFilter((prev) => ({ ...prev, [name]: value }));
  };

  const handleEnquiryFilterSubmit = () => {
    setFilterValue("");
    setPage(0);
    dispatch(
      GetAllEnquiry({
        country: enquiryFilter.country || undefined,
        treatingIn: enquiryFilter.treatingIn || undefined,
        status: enquiryFilter.status || undefined,
      }),
    );
  };

  const handleEnquiryFilterClear = () => {
    setEnquiryFilter({ country: "", treatingIn: "", status: "" });
    setFilterValue("");
    setPage(0);
    dispatch(GetAllEnquiry());
  };

  useEffect(() => {
    if (tabValue === 4) {
      getSosList();
    }
  }, [tabValue, getSosList]);

  useEffect(() => {
    if (tabValue === 5) {
      getSocialMediaList(socialMediaPage);
    }
  }, [tabValue, socialMediaPage, getSocialMediaList]);

  useEffect(() => {
    if (tabValue === 6) {
      getChatbotLeadsList(chatbotLeadsPage);
    }
  }, [tabValue, chatbotLeadsPage, getChatbotLeadsList]);

  // Keep Emergency SOS list live: socket events + polling + tab focus
  useEffect(() => {
    if (tabValue !== 4) return undefined;

    const token = localStorage.getItem("token");
    if (token) connectSosSocket(token);

    const refreshQuiet = () => getSosListRef.current?.({ silent: true });

    // Debounce rapid socket bursts (new alert + escalation + dismiss)
    let debounceTimer = null;
    const scheduleRefresh = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshQuiet, 400);
    };

    const unsubAlert = onSosWebAlert(() => {
      scheduleRefresh();
    });
    const unsubDismiss = onSosAlertDismissed(() => {
      scheduleRefresh();
    });

    const pollId = setInterval(refreshQuiet, SOS_LIST_POLL_MS);

    const onVisible = () => {
      if (document.visibilityState === "visible") refreshQuiet();
    };
    const onFocus = () => refreshQuiet();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onFocus);

    return () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      unsubAlert();
      unsubDismiss();
      clearInterval(pollId);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onFocus);
    };
  }, [tabValue]);

  useEffect(() => {
    const savedTab = localStorage.getItem("tabenquiry");
    const permittedValues = filteredTabs.map((t) => t.value);

    if (savedTab !== null && permittedValues.includes(Number(savedTab))) {
      setTabValue(Number(savedTab));
    } else if (permittedValues.length > 0) {
      setTabValue(permittedValues[0]);
      localStorage.setItem("tabenquiry", permittedValues[0]);
    }
  }, [permissions, filteredTabs.length]);
  console.log(searchApiData);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const EditButton = (e, id) => {
    navigate("/Admin/edit-Enquiry", {
      state: {
        enquiryId: id,
      },
    });
  };
  const EditAmbulance = (e, info) => {
    localStorage.setItem("tabenquiry", "1");
    navigate("/Admin/edit-ambulance", {
      state: {
        id: info?.raw?.id || info?.id,
        user_id: info?.raw?.user_id || info?.user_id,
        enquiryId: info?.enquiryId,
      },
    });
  };
  const EditAirAmbulance = (e, info) => {
    localStorage.setItem("tabenquiry", "2");
    navigate("/Admin/edit-air-ambulance", {
      state: {
        id: info?.raw?.id || info?.id,
        enquiryId: info?.enquiryId,
      },
    });
  };
  const EditTreatmentEstimate = (e, info) => {
    localStorage.setItem("tabenquiry", "3");
    navigate("/Admin/edit-treatment-estimate", {
      state: {
        id: info?.raw?.id || info?.id,
        enquiryId: info?.enquiryId,
      },
    });
  };
  const handleDeleteExternal = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
    });
    if (!result.isConfirmed) return;
    try {
      const payload = {
        id: row.raw?.id || row.enquiryId, // ✅ safe id
        model:
          tabValue === 1
            ? "AmbulanceRequest"
            : tabValue === 2
              ? "AirAmbulance"
              : tabValue === 3
                ? "PatientQuery"
                : "",
        status: "Deleted",
      };
      const res = await axios.post(
        `${AdminBaseUrl}update_user_request_status`,
        payload,
      );
      if (res?.data?.success) {
        Swal.fire("Deleted!", "Record deleted successfully", "success");
        await dispatch(testForms()); // external data
        await getUserId(); // tab data reload
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error!", "Something went wrong", "error");
    }
  };
  const ViewDetail = (e, type, info) => {
    console.log(e, type, info);
    const routeMap = {
      0: "/Admin/Enquiry-Detail",
      1: "/Admin/Enquiry-DetailAmbulance",
      2: "/Admin/airambulanceview",
      3: "/Admin/medicalescortservice",
    };
    const path = routeMap[type];
    if (!path) return;
    console.log(type);
    localStorage.setItem("tabenquiry", type);
    navigate(path, {
      state: {
        id: type === 0 ? info.enquiryId : info.id, // ✅ FIX
        enquiryId: info.enquiryId, // optional
        type: type,
      },
    });
  };
  const sendToPatientAPI = async (type, data) => {
    console.log(data);
    try {
      const response = await axios.post(`${baseurl}createPatientFromExternal`, {
        enquiry_type: type,
        data: data,
      });
      if (response.data.success) {
        await get3tabdata(datauserId, getcountries, roleStatuses);
        // Swal.fire("Success!", `${type} converted to patient`, "success");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error!", "Something went wrong", "error");
    }
  };
  const handleChangtype = async (e, b) => {
    const value = e?.value || e?.target?.value;
    console.log(tabValue);
    console.log(e);
    console.log(value);
    const data1 = parseInt(value);
    const data = {
      id: b?.id,
      status: statusMap[data1],
      model:
        tabValue === 1
          ? "AmbulanceRequest"
          : tabValue === 2
            ? "AirAmbulance"
            : tabValue === 3
              ? "PatientQuery"
              : "",
    };
    try {
      const response = await axios.post(
        `${AdminBaseUrl}update_user_request_status`,
        data,
      );
      dispatch(testForms());
      await get3tabdata(datauserId, getcountries, roleStatuses);
      if (response?.data?.success) {
        // Swal.fire("Success", "Status Updated Successfully", "success");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("tabenquiry", newValue);
    setRows([]);
    setSearchApiData([]);
    setPage(0);
    setFilterValue("");
    if (newValue === 5) setSocialMediaPage(1);
    if (newValue === 6) setChatbotLeadsPage(1);
  };

  const handleViewLeadDetail = (info) => {
    setSelectedLead(info);
    setLeadDetailOpen(true);
  };

  const handleCloseLeadDetail = () => {
    setLeadDetailOpen(false);
    setSelectedLead(null);
  };

  const formatLeadDate = (dateValue) => {
    if (!dateValue) return "—";
    const d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return String(dateValue);
    return `${d.toLocaleDateString("en-GB")} - ${d.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;
  };
  const handleChange = async (event, id, tabValue, data) => {
    if (isReferral) return;
    console.log(event, id, tabValue, data);
    const { value } = event.target;
    const status = Number(value);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to update / convert?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!result.isConfirmed) return;
    if (tabValue === 0) {
      // if (status === 1) {
      //   console.log(data);
      //   try {

      //     const payload = {
      //       full_name: data.raw.name,
      //       email: data.raw.email,
      //       phone_code: data.raw.phoneCode,
      //       phone: data.raw.emergency_contact,
      //       passport_number: data.raw.passport_num,
      //       user_type: 2,
      //       doctor_review: data.raw.doctorReview,
      //       age: data.raw.age,
      //       address: data.raw.address,
      //       town: data.raw.town,
      //       country: data.raw.country,
      //       passport_number: data.raw.passport_num,
      //     };
      //     if (
      //       data.raw.user_id === "" ||
      //       data.raw.user_id === null ||
      //       data.raw.user_id === undefined
      //     ) {
      //       console.log("11111111111111111");

      //       const response = await axios.post(
      //         "https://omcacrm.com/omca/api/user_registration",
      //         payload
      //       );
      //         if (response.data.success) {
      //           await dispatch(
      //             EnquiryStatus({
      //               id,
      //               status,
      //               enquiry_type: "OMCA Enquiry",
      //               user_id: response.data.data.id,
      //             }),
      //           ).unwrap();
      //         }
      //       }else{
      //       console.log("22222222222222");
      //         await dispatch(
      //           EnquiryStatus({
      //             id,
      //             status,
      //             enquiry_type: "OMCA Enquiry",
      //             user_id: data.raw.user_id,
      //           }),
      //         ).unwrap();
      //       }
      //       Swal.fire("Success!", "Converted to patient!", "success");
      //       dispatch(GetAllEnquiry());
      //   } catch (err) {
      //     Swal.fire("Error!", err?.message || "Error", "error");
      //   }
      // } else {
      //   await dispatch(
      //     EnquiryStatus({
      //       id,
      //       status,
      //       enquiry_type: "OMCA Enquiry",
      //     }),
      //   ).unwrap();
      //   Swal.fire("Success!", "Status Change Successfully!", "success");
      //   dispatch(GetAllEnquiry());
      // }

      if (status === 1) {
        console.log(data);

        try {
          let userId = data.raw.user_id;

          const payload = {
            full_name: data.raw.name,
            email: data.raw.email,
            phone_code: data.raw.phoneCode,
            phone: data.raw.emergency_contact,
            passport_number: data.raw.passport_num,
            user_type: 2,
            doctor_review: data.raw.doctorReview,
            age: data.raw.age,
            address: data.raw.address,
            town: data.raw.town,
            country: data.raw.country,
          };

          // Create/Get user only if user_id is missing
          // if (!userId) {
          //   console.log("Creating user...");

          //   try {
          //     const response = await axios.post(
          //       "https://omcacrm.com/omca/api/user_registration",
          //       payload,
          //     );

          //     // Take ID whether success is true or false
          //     userId = response?.data?.data?.id;
          //   } catch (error) {
          //     // Do not show frontend error
          //     console.error(
          //       "User registration API error:",
          //       error?.response?.data || error.message,
          //     );

          //     // Try to get user id from error response if available
          //     userId = error?.response?.data?.data?.id;
          //   }
          // }

          const existingPatientId = data.raw?.patientId;
          const hasUserId = Boolean(userId && String(userId).trim() !== "");
          const isNewPatient = !hasUserId && !existingPatientId;

          const res = await dispatch(
            EnquiryStatus({
              id,
              status,
              enquiry_type: "OMCA Enquiry",
              user_id: userId,
              patientId: existingPatientId || undefined,
              createNewPatient: isNewPatient,
            }),
          ).unwrap();

          if (res?.isDuplicatePhone) {
            const confirmDup = await Swal.fire({
              title: "Duplicate Phone Number Detected",
              text: res.message,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });

            if (confirmDup.isConfirmed) {
              const forcedRes = await dispatch(
                EnquiryStatus({
                  id,
                  status,
                  enquiry_type: "OMCA Enquiry",
                  user_id: userId,
                  forceCreate: true,
                  patientId: existingPatientId || undefined,
                  createNewPatient: isNewPatient,
                }),
              ).unwrap();

              if (forcedRes?.success === false) {
                Swal.fire("Error!", forcedRes?.message || "Failed to convert to patient!", "error");
              } else {
                Swal.fire("Success!", forcedRes?.message || "Converted to patient!", "success");
              }
              dispatch(GetAllEnquiry());
            } else {
              Swal.fire({
                icon: "info",
                title: "New Phone Number Required",
                text: "Please edit the enquiry to use a different phone number before confirming as patient.",
              });
              dispatch(GetAllEnquiry());
            }
            return;
          }

          if (res?.success === false) {
            Swal.fire("Error!", res?.message || "Failed to convert to patient!", "error");
            dispatch(GetAllEnquiry());
            return;
          }

          Swal.fire("Success!", "Converted to patient!", "success");
          dispatch(GetAllEnquiry());
        } catch (err) {
          if (err?.isDuplicatePhone) {
            const existingPatientId = data.raw?.patientId;
            const hasUserId = Boolean(data.raw?.user_id && String(data.raw?.user_id).trim() !== "");
            const isNewPatient = !hasUserId && !existingPatientId;

            const confirmDup = await Swal.fire({
              title: "Duplicate Phone Number Detected",
              text: err.message,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });

            if (confirmDup.isConfirmed) {
              try {
                const forcedRes = await dispatch(
                  EnquiryStatus({
                    id,
                    status,
                    enquiry_type: "OMCA Enquiry",
                    user_id: data.raw?.user_id,
                    forceCreate: true,
                    patientId: existingPatientId || undefined,
                    createNewPatient: isNewPatient,
                  }),
                ).unwrap();

                if (forcedRes?.success === false) {
                  Swal.fire("Error!", forcedRes?.message || "Failed to convert to patient!", "error");
                } else {
                  Swal.fire("Success!", forcedRes?.message || "Converted to patient!", "success");
                }
              } catch (forcedErr) {
                Swal.fire("Error!", forcedErr?.message || "Error", "error");
              }
              dispatch(GetAllEnquiry());
            } else {
              Swal.fire({
                icon: "info",
                title: "New Phone Number Required",
                text: "Please edit the enquiry to use a different phone number before confirming as patient.",
              });
              dispatch(GetAllEnquiry());
            }
            return;
          }

          Swal.fire("Error!", err?.message || "Error", "error");
          dispatch(GetAllEnquiry());
        }
      } else {
        try {
          const res = await dispatch(
            EnquiryStatus({
              id,
              status,
              enquiry_type: "OMCA Enquiry",
            }),
          ).unwrap();

          if (res?.success === false) {
            Swal.fire("Error!", res?.message || "Failed to update status", "error");
          } else {
            Swal.fire("Success!", "Status Change Successfully!", "success");
          }
          dispatch(GetAllEnquiry());
        } catch (err) {
          Swal.fire("Error!", err?.message || "Error", "error");
          dispatch(GetAllEnquiry());
        }
      }
    } else {
      if (status === 1) {
        try {
          if (tabValue === 1) {
            await sendToPatientAPI("Ambulance Service", data.raw);
          }
          if (tabValue === 2) {
            await sendToPatientAPI("Air Medical Escort", data.raw);
          }
          if (tabValue === 3) {
            await sendToPatientAPI("Treatment Estimate", data.raw);
          }
          await handleChangtype({ value }, data.raw);
          Swal.fire("Success!", "Converted to patient!", "success");
          dispatch(GetAllEnquiry());
        } catch (err) {
          Swal.fire("Error!", err?.message || "Error", "error");
        }
      } else {
        await handleChangtype({ value }, data.raw);

        Swal.fire("Success!", "Status changed!", "success");
        dispatch(GetAllEnquiry());
      }
    }
  };
  const handleSampleFile = async () => {
    try {
      const response = await axios.get(`${baseurl}export_enquiries`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Sample Enquiry.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: "Sample_Enquiry.xlsx has been downloaded successfully!",
        timer: 3000,
        showConfirmButton: false,
      });
      return response.data;
    } catch (err) {
      console.error(
        "Error downloading the sample file:",
        err.response?.data?.message || err.message,
      );
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: err.response?.data?.message || "Something went wrong!",
      });
      throw err;
    }
  };
  const handleHospitalChange = (event, newValue) => {
    setReport((prev) => ({ ...prev, hospital: newValue }));
  };
  const handleImportFile = async (e) => {
    e.preventDefault();
    if (!selectedImage) {
      toast.error("Please select a file before uploading.");
      return;
    }
    await runSubmit("import", async () => {
      const formData = new FormData();
      formData.append("file", selectedImage);
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }
      try {
        const result = await dispatch(ImportEnquirys(formData)).unwrap();
        setOpen3(false);
        dispatch(GetAllEnquiry());
        Swal.fire("Success!", `${result.message}`, "success");
      } catch (err) {
        console.log(err);
        setOpen3(false);
        Swal.fire("Error!", err?.error || "An error occurred", "error");
      }
    });
  };
  const handleFilter = (event) => {
    const value = event.target.value.toLowerCase().trim();
    setFilterValue(event.target.value);
    setPage(0);
    if (!value) {
      setRows(searchApiData);
      return;
    }
    const filterResult = searchApiData.filter((item) => {
      return (
        String(item.enquiryId || "")
          .toLowerCase()
          .includes(value) ||
        String(item.email || "")
          .toLowerCase()
          .includes(value) ||
        String(item.country || "")
          .toLowerCase()
          .includes(value) ||
        String(item.name || "")
          .toLowerCase()
          .includes(value) ||
        String(item.age || "")
          .toLowerCase()
          .includes(value) ||
        String(item.emergency_contact || "")
          .toLowerCase()
          .includes(value) ||
        String(item.disease_name || "")
          .toLowerCase()
          .includes(value) ||
        String(item.sosId || "")
          .toLowerCase()
          .includes(value) ||
        String(item.emergencyCaseId || "")
          .toLowerCase()
          .includes(value) ||
        String(item.patientId || "")
          .toLowerCase()
          .includes(value) ||
        String(item.mobileNumber || item.phone || "")
          .toLowerCase()
          .includes(value) ||
        String(item.source || "")
          .toLowerCase()
          .includes(value) ||
        String(item.channelType || "")
          .toLowerCase()
          .includes(value) ||
        String(item.countryCode || "")
          .toLowerCase()
          .includes(value) ||
        String(item.status || "")
          .toLowerCase()
          .includes(value) ||
        String(item.sosType || "")
          .toLowerCase()
          .includes(value) ||
        formatEmergencyContacts(item.emergency_contacts)
          .toLowerCase()
          .includes(value)
      );
    });
    setRows(filterResult);
  };
  const handleClearFilter = () => {
    setFilterValue("");
    setRows(searchApiData);
    setPage(0); // ⭐ RESET PAGE
  };
  useEffect(() => {
    setPage(0);
  }, [rows]);
  const [age, setAge] = React.useState("");
  const handleChange3 = (event) => {
    setAge(event.target.value);
  };
  const handleNotesdata = async (e) => {
    e.preventDefault();
    setBlogErr({
      note: false,
      date: false,
    });
    if (!note) {
      setBlogErr((prevState) => ({ ...prevState, note: true }));
    }
    if (!date) {
      setBlogErr((prevState) => ({ ...prevState, date: true }));
    }
    if (!note || !date) {
      return;
    }
    await runSubmit("notes", async () => {
      try {
        let response;
        if (tabValue === 1 || tabValue === 2 || tabValue === 3) {
          const noteModelTypeMap = {
            1: "AmbulanceRequest",
            2: "AirAmbulance",
            3: "PatientQuery",
          };
          response = await axios.post(`${AdminBaseUrl}enquiry_note/store`, {
            enquiry_id: enqId,
            model_type: noteModelTypeMap[tabValue],
            notes: note,
            date: date,
          });
        } else {
          response = await axios.post(`${baseurl}add_notes/${enqId}`, {
            note: note,
            date: date,
          });
        }
        console.log(response);
        setBlogErr(false);
        if (response.status === 200 || response?.data?.success) {
          setOpen2(false);
          Swal.fire("Success", "Notes added successfully!", "success");
        }
        setNote("");
        setDate("");
      } catch (error) {
        setOpen2(false);
        console.log(error);
        Swal.fire("Error", `${error?.response?.data?.message}`, "error");
      }
    });
  };

  const handledelete = (e, patientId) => {
    console.log(e);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(DeleteEnquiry({ id: e }))
            .unwrap()
            .then(() => {
              return dispatch(GetAllEnquiry());
            })
            .then((newData) => {
              Swal.fire("Deleted!", " enquiry has been deleted.", "success");
              const normalized = normalizeData(
                newData.payload || [],
                "enquiry",
              );
              setRows(normalized);
              setSearchApiData(normalized);
            })
            .catch((err) => {
              Swal.fire("Error!", err?.message || "An error occurred", "error");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            icon: "error",
          });
        }
      });
  };
  const donloadpdf = async () => {
    const maxRows = rows.length || 1;
    Swal.fire({
      title: "Enter number of rows for PDF",
      input: "number",
      inputLabel: `Choose between 1 and ${maxRows}`,
      inputAttributes: {
        min: "1",
        max: maxRows.toString(),
        step: "1",
      },
      inputValue: rowsPerPage,
      showCancelButton: true,
      confirmButtonText: "Generate PDF",
    }).then((result) => {
      if (result.isConfirmed) {
        const userInput = parseInt(result.value, 10);
        if (isNaN(userInput) || userInput < 1 || userInput > maxRows) {
          Swal.fire(
            "Invalid entry",
            `Please enter a number between 1 and ${maxRows}`,
            "error",
          );
          return;
        }
        setPdfRowLimit(userInput);
        setTimeout(() => {
          toPDF();
          setPdfRowLimit(null); // reset to normal view
        }, 300);
      }
    });
  };
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && orderDirection === "asc";
    const direction = isAsc ? "desc" : "asc";
    setOrderDirection(direction);
    setOrderBy(property);
    const sortedData = [...rows].sort((a, b) => {
      let valA = a[property];
      let valB = b[property];
      // ✅ Handle null/undefined
      if (!valA) valA = "";
      if (!valB) valB = "";
      // ✅ Special handling for DATE
      if (property === "date") {
        return direction === "asc"
          ? new Date(valA) - new Date(valB)
          : new Date(valB) - new Date(valA);
      }
      if (property === "enquiryId" || property === "age") {
        return direction === "asc"
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      }
      valA = valA.toString().toLowerCase();
      valB = valB.toString().toLowerCase();
      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setRows(sortedData);
  };
  useEffect(() => {
    let filtered = [];
    if (tabValue === 0 && Enquiry?.length) {
      filtered = normalizeData(Enquiry, "enquiry");
    }
    if (tabValue === 1 && ambulanceData?.length) {
      filtered = normalizeData(ambulanceData, "ambulance");
    }
    if (tabValue === 2 && airAmbulanceData?.length) {
      filtered = normalizeData(airAmbulanceData, "air");
    }
    if (tabValue === 3 && treatmentData?.length) {
      filtered = normalizeData(treatmentData, "treatment");
    }
    if (tabValue === 4 && sosData?.length) {
      filtered = normalizeSosData(sosData);
    }
    if (tabValue === 5 && socialMediaData?.length) {
      filtered = socialMediaData;
    }
    if (tabValue === 6 && chatbotLeadsData?.length) {
      filtered = chatbotLeadsData;
    }
    setRows(filtered);
    setSearchApiData(filtered);
  }, [
    tabValue,
    Enquiry,
    ambulanceData,
    airAmbulanceData,
    treatmentData,
    sosData,
    socialMediaData,
    chatbotLeadsData,
  ]);
  const handleSubmitAppointment = async () => {
    const { appointment_Date, appointment_Time, Notes } = appointmentData;
    if (!appointment_Date) {
      return Swal.fire("Error", "Please select appointment date", "error");
    }
    if (!appointment_Time) {
      return Swal.fire("Error", "Please select appointment time", "error");
    }
    if (!Notes) {
      return Swal.fire("Error", "Please enter notes", "error");
    }
    if (images.length === 0) {
      return Swal.fire("Error", "Please upload at least one report", "error");
    }
    console.log(appointmentData);
    await runSubmit("appointment", async () => {
      try {
        const formData = new FormData();
        formData.append("enquiryId", appointmentData.enquiry_id);
        formData.append("hospital_id", appointmentData.hospital_id);
        formData.append("hospitalName", appointmentData.hospitalName);
        formData.append("hospital_email", appointmentData.hospital_email);
        formData.append("health_issue", appointmentData.health_issue);
        formData.append("Notes", appointmentData.Notes);
        formData.append("appointment_Date", appointmentData.appointment_Date);
        formData.append(
          "appointment_Time",
          formatTime12Hour(appointmentData.appointment_Time),
        );
        formData.append("enq_userName", appointmentData.enq_userName);
        formData.append("enq_phoneNumber", appointmentData?.enq_phoneNumber);
        formData.append("user_id", appointmentData?.user_id);
        // formData.append("enq_country_code", appointmentData.enq_country_code);
        formData.append("enq_email", appointmentData.enq_email);
        images.forEach((file) => {
          formData.append("reports", file);
        });
        const res = await axios.post(
          `${baseurl}/create_enquiry_appointment/${usrFount}`,
          formData,
        );
        if (res.data.success) {
          Swal.fire("Success", "Appointment Created", "success");
          handleCloseAppointment();
        }
      } catch (err) {
        console.log(err);
        Swal.fire("Error", "Something went wrong", "error");
      }
    });
  };
  const usrFount = localStorage.getItem("_id");
  // const handleSubmitAppointment = async () => {
  //   const { patient_name, doctor_name, date, time } = appointmentData;

  //   if (!patient_name || !doctor_name || !date || !time) {
  //     return Swal.fire("Error", "All fields are required", "error");
  //   }

  //   try {
  //     const res = await axios.post(`${AdminBaseUrl}appointment/store`, appointmentData);

  //     if (res?.data?.success) {
  //       Swal.fire("Success", "Appointment added successfully", "success");
  //       handleCloseAppointment();
  //     }
  //   } catch (error) {
  //     Swal.fire("Error", "Something went wrong", "error");
  //   }
  // };
  const handleAppointmentChange = (e) => {
    const { name, value } = e.target;
    setAppointmentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleOpenAppointment = (info) => {
    console.log(info);
    setAppointmentData({
      hospital_id: "",
      hospitalName: "",
      health_issue: "",
      Notes: "",
      appointment_Date: "",
      appointment_Time: "",
      enq_userName: info.name,
      enq_phoneNumber: info.raw.phone,
      user_id: info.raw.user_id,
      enq_email: info.email,
      enquiry_id: info.enquiryId,
    });
    setOpenAppointment(true);
  };
  const handleCloseAppointment = () => {
    setOpenAppointment(false);
    setImages([]);
    setAppointmentData({
      patient_name: "",
      doctor_name: "",
      date: "",
      time: "",
      notes: "",
      user_id: "",
      enq_userName: "",
      enq_phoneNumber: "",
      enq_email: "",
    });
  };
  const normalizeData = (data, type) => {
    return data.map((item) => ({
      enquiryId: item.enquiryId || item.id || 0,
      name: item.name || item.first_name || "",
      email: item.email || "",
      country: item.country || "",
      createdBy: item.createdBy || "",
      treatingIn: Array.isArray(item.treatingIn)
        ? item.treatingIn.join(", ")
        : item.treatingIn || item.treating_in_country || "",
      emergency_contact: item.emergency_contact || item.phone || "",
      disease_name:
        item.disease_name || item.services?.replaceAll("_", " ") || "",
      Enquiry_status: item.Enquiry_status || item.status || "",
      date: item.createdAt || item.created_at || "",
      id: item.id,
      raw: item,
      enq_userName: item.name,
      hasAppointment: item.hasAppointment,
      hasDoctorReview: item.hasDoctorReview,
      enq_email: item.email,
    }));
  };
  const setHospitalFunction = async () => {
    try {
      const response = await axios.post(`${AdminBaseUrl}hospital_list`);
      if (response.data.success) {
        console.log(response.data.data);
        setHospitalList(response.data.data);
      }
    } catch (error) { }
  };
  const getUserId = async () => {
    try {
      const response = await axios.get(`${baseurl}get_patient_user_ids`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.data.success) {
        console.log(response.data);
        console.log("a");
        get3tabdata(
          response.data.user_ids,
          response.data.accessCountries,
          response.data.roleStatuses,
        );
        console.log("b");
        setGetcountries(response.data.accessCountries);
        setRoleStatuses(response.data.roleStatuses);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row gx-3">
            <div className="col-md-12">
              <div className="topmainhd">
                <h6>
                  {tabValue === 0
                    ? "Manage Enquiries"
                    : tabValue === 1
                      ? "Manage Ambulance Service"
                      : tabValue === 2
                        ? "Manage Air Medical escort"
                        : tabValue === 3
                          ? "Manage Treatment Estimate"
                          : tabValue === 4
                            ? "SOS Emergency Requests"
                            : tabValue === 5
                              ? "Campaign Contacts"
                              : tabValue === 6
                                ? "Chatbot Leads"
                                : ""}
                </h6>
              </div>
            </div>
            <div className="col-md-12">
              <div className="country-top">
                <div className="">
                  <Box>
                    <Tabs
                      value={tabValue}
                      onChange={handleTabChange}
                      TabIndicatorProps={{
                        style: {
                          display: "none",
                        },
                      }}
                      sx={{
                        minHeight: "40px",
                        "& .MuiTabs-flexContainer": {
                          gap: "10px",
                        },
                      }}
                    >
                      {filteredTabs.map((tab) => (
                        <Tab
                          sx={{
                            textTransform: "none",
                            fontSize: "12px",
                            fontWeight: 500,
                            fontFamily: "Rubik",
                            padding: "8px 18px",
                            lineHeight: "22px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            color: "#666",
                            transition: "0.3s",
                            minHeight: "0px",
                            "&.Mui-selected": {
                              background: "#22c7b8",
                              color: "#fff",
                            },
                          }}
                          key={tab.value}
                          label={tab.label}
                          value={tab.value}
                        />
                      ))}
                    </Tabs>
                  </Box>
                </div>
                <div className="search-btn-main">
                  <div className="">
                    <TextField
                      className="field-count"
                      label="Search"
                      id="outlined-required"
                      size="small"
                      value={filterValue}
                      onChange={handleFilter} // Pass event directly
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {filterValue && (
                              <IconButton
                                onClick={handleClearFilter}
                                edge="end"
                                className="input-set"
                              >
                                <ClearIcon />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  {tabValue === 0 ? (
                    <>
                      <Link to="/Admin/add-Enquiry" className="add-button">
                        <i className="fa fa-plus me-2"></i>New Enquiry
                      </Link>
                      <button
                        onClick={(e) => handleClickOpen3(e)}
                        className="add-button"
                      >
                        <i className="fa fa-file-excel-o me-2"></i>Import
                      </button>
                      {allowExport && (
                        <button onClick={handleSampleFile} className="add-button">
                          <i className="fa fa-file me-2"></i>Export
                        </button>
                      )}
                      {role === "Admin" ? (
                        <button onClick={donloadpdf} className="add-button">
                          <i className="fa fa-file-pdf-o me-2"></i>Pdf
                        </button>
                      ) : (
                        ""
                      )}
                    </>
                  ) : tabValue === 1 ? (
                    <Link
                      to="/Admin/add-ambulance"
                      className="add-button"
                      onClick={() => localStorage.setItem("tabenquiry", "1")}
                    >
                      <i className="fa fa-plus me-2"></i>Create
                    </Link>
                  ) : tabValue === 2 ? (
                    <Link
                      to="/Admin/add-air-ambulance"
                      className="add-button"
                      onClick={() => localStorage.setItem("tabenquiry", "2")}
                    >
                      <i className="fa fa-plus me-2"></i>Create
                    </Link>
                  ) : tabValue === 3 ? (
                    <Link
                      to="/Admin/add-treatment-estimate"
                      className="add-button"
                      onClick={() => localStorage.setItem("tabenquiry", "3")}
                    >
                      <i className="fa fa-plus me-2"></i>Create
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            {tabValue === 0 && (
              <div className="col-md-12">
                <div className="main_content mb-3">
                  <div className="row gx-3 align-items-end">
                    <div className="col-md-3">
                      <div className="field-set">
                        <label>
                          Country
                        </label>
                        <FormControl fullWidth size="small">
                          <Select
                            name="country"
                            value={enquiryFilter.country}
                            onChange={handleEnquiryFilterChange}
                            displayEmpty
                            input={<OutlinedInput placeholder="Select Country" />}
                            sx={{ height: 40 }}
                            className="select-country form-control"
                            MenuProps={{
                              PaperProps: {
                                style: { maxHeight: 200 },
                              },
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return <span>Select Country</span>;
                              }
                              return selected;
                            }}
                          >
                            <MenuItem value="" className="custmselect">
                              Select Country
                            </MenuItem>
                            {Countries && Countries.length > 0 ? (
                              Countries.map((con, idx) => (
                                <MenuItem
                                  className="custmselect"
                                  key={idx}
                                  value={con.name}
                                >
                                  {con.name}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No countries available</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="field-set">
                        <label>
                          Treating In Country
                        
                        </label>
                        <FormControl fullWidth size="small">
                          <Select
                            name="treatingIn"
                            value={enquiryFilter.treatingIn}
                            onChange={handleEnquiryFilterChange}
                            displayEmpty
                            input={
                              <OutlinedInput placeholder="Select Country" />
                            }
                            sx={{ height: 40 }}
                            className="select-country form-control"
                            MenuProps={{
                              PaperProps: {
                                style: { maxHeight: 200 },
                              },
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return <span>Select Country</span>;
                              }
                              return selected;
                            }}
                          >
                            <MenuItem value="" className="custmselect">
                              Select Country
                            </MenuItem>
                            {Countries && Countries.length > 0 ? (
                              Countries.map((con, idx) => (
                                <MenuItem
                                  className="custmselect"
                                  key={idx}
                                  value={con.name}
                                >
                                  {con.name}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No countries available</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="field-set">
                        <label>
                          Status
                        </label>
                        <FormControl fullWidth size="small">
                          <Select
                            name="status"
                            value={enquiryFilter.status}
                            onChange={handleEnquiryFilterChange}
                            displayEmpty
                            input={
                              <OutlinedInput placeholder="Select Status" />
                            }
                            sx={{ height: 40 }}
                            className="select-country form-control"
                            MenuProps={{
                              PaperProps: {
                                style: { maxHeight: 200 },
                              },
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return <span>Select Status</span>;
                              }
                              if (selected === "Dead") return "Close";
                              if (selected === "1 Visit") return "Visit 1";
                              if (selected === "2 Visit") return "Visit 2";
                              return selected;
                            }}
                          >
                            <MenuItem value="" className="custmselect">
                              Select Status
                            </MenuItem>
                            <MenuItem value="Pending" className="custmselect">
                              Pending
                            </MenuItem>
                            {/* <MenuItem value="Confirmed" className="custmselect">
                              Confirm
                            </MenuItem> */}
                            <MenuItem value="Hold" className="custmselect">
                              Hold
                            </MenuItem>
                            <MenuItem value="Follow-Up" className="custmselect">
                              Follow-Up
                            </MenuItem>
                            <MenuItem value="1 Visit" className="custmselect">
                              Visit 1
                            </MenuItem>
                            <MenuItem value="2 Visit" className="custmselect">
                              Visit 2
                            </MenuItem>
                            <MenuItem value="Visa" className="custmselect">
                              Visa
                            </MenuItem>
                            <MenuItem value="Dead" className="custmselect">
                              Close
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-md-3 mb-4">
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          type="button"
                          className="add-button"
                          onClick={handleEnquiryFilterSubmit}
                        >
                          Filter
                        </button>
                        {(enquiryFilter.country ||
                          enquiryFilter.treatingIn ||
                          enquiryFilter.status) && (
                          <button
                            type="button"
                            className="add-button"
                            onClick={handleEnquiryFilterClear}
                          >
                            Clear
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-12">
              <div className="main_content">
                <div className="table-responsive">
                  <TableContainer
                    component={Paper}
                    style={{ overflowX: "auto" }}
                    ref={targetRef}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className="table-no-card"
                    >
                      {tabValue === 4 ? (
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sr.No.</TableCell>
                              <TableCell>Emergency Case</TableCell>
                              <TableCell>User Name</TableCell>
                              <TableCell>Contact Number</TableCell>
                              <TableCell>SOS Type</TableCell>
                              <TableCell>Date & Time</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sosLoading ? (
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div className="flex justify-center py-4">
                                    <p className="text-center text-gray-500">
                                      Loading SOS requests...
                                    </p>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ) : (pdfRowLimit
                              ? rows.slice(0, pdfRowLimit)
                              : rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage,
                              )
                            ).length > 0 ? (
                              (pdfRowLimit
                                ? rows.slice(0, pdfRowLimit)
                                : rows.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage,
                                )
                              ).map((info, i) => (
                                <TableRow key={info.sosId || info.id || i}>
                                  <TableCell>
                                    {pdfRowLimit
                                      ? i + 1
                                      : page * rowsPerPage + i + 1}
                                  </TableCell>
                                  <TableCell
                                    title={formatSosDisplayValue(
                                      info.emergencyCaseId,
                                    )}
                                  >
                                    {formatSosDisplayValue(info.emergencyCaseId)}
                                  </TableCell>
                                  <TableCell
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => ViewSosDetail(e, info)}
                                    title={`${info.name}${info.patientId ? ` (${info.patientId})` : ""}`}
                                  >
                                    {truncateCellText(info.name)}
                                  </TableCell>
                                  <TableCell
                                    style={{ minWidth: 180, maxWidth: 240 }}
                                    title={formatSosDisplayValue(info.mobileNumber)}
                                  >
                                    {truncateCellText(
                                      formatSosDisplayValue(info.mobileNumber),
                                      50,
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {formatSosDisplayValue(info.sosType)}
                                  </TableCell>
                                  <TableCell>
                                    {info.date
                                      ? `${new Date(info.date).toLocaleDateString("en-GB")} - ${new Date(info.date).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true })}`
                                      : "—"}
                                  </TableCell>
                                  <TableCell
                                    title={formatSosDisplayValue(info.status)}
                                  >
                                    {truncateCellText(
                                      formatSosDisplayValue(info.status),
                                      15,
                                    )}
                                  </TableCell>
                                  <TableCell className="action-icon">
                                    <Tooltip title="Open SOS Alert">
                                      <NotificationsActiveIcon
                                        className="eye-icon"
                                        style={{
                                          color: "#e53935",
                                          marginRight: 8,
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => OpenSosAlertModal(e, info)}
                                      />
                                    </Tooltip>
                                    <Tooltip title="View SOS Details">
                                      <VisibilityIcon
                                        className="eye-icon"
                                        onClick={(e) => ViewSosDetail(e, info)}
                                      />
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div className="flex justify-center py-4">
                                    <p className="text-center text-gray-500">
                                      No SOS Requests Found
                                    </p>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </>
                      ) : isLeadTab ? (
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sr.No.</TableCell>
                              {tabValue === 5 ? (
                                <>
                                  <TableCell>
                                    <TableSortLabel
                                      active={orderBy === "name"}
                                      direction={
                                        orderBy === "name"
                                          ? orderDirection
                                          : "asc"
                                      }
                                      onClick={() => handleRequestSort("name")}
                                    >
                                      Name
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell>Phone</TableCell>
                                  <TableCell>Already Exists</TableCell>
                                  <TableCell>
                                    <TableSortLabel
                                      active={orderBy === "date"}
                                      direction={
                                        orderBy === "date"
                                          ? orderDirection
                                          : "asc"
                                      }
                                      onClick={() => handleRequestSort("date")}
                                    >
                                      Date & Time
                                    </TableSortLabel>
                                  </TableCell>
                                </>
                              ) : (
                                <>
                                  <TableCell>
                                    <TableSortLabel
                                      active={orderBy === "name"}
                                      direction={
                                        orderBy === "name"
                                          ? orderDirection
                                          : "asc"
                                      }
                                      onClick={() => handleRequestSort("name")}
                                    >
                                      Name
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell>Phone</TableCell>
                                  <TableCell>
                                    <TableSortLabel
                                      active={orderBy === "country"}
                                      direction={
                                        orderBy === "country"
                                          ? orderDirection
                                          : "asc"
                                      }
                                      onClick={() =>
                                        handleRequestSort("country")
                                      }
                                    >
                                      Country
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell>Status</TableCell>
                                  <TableCell>
                                    <TableSortLabel
                                      active={orderBy === "date"}
                                      direction={
                                        orderBy === "date"
                                          ? orderDirection
                                          : "asc"
                                      }
                                      onClick={() => handleRequestSort("date")}
                                    >
                                      Date & Time
                                    </TableSortLabel>
                                  </TableCell>
                                </>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(tabValue === 5
                              ? socialMediaLoading
                              : chatbotLeadsLoading) ? (
                              <TableRow>
                                <TableCell
                                  colSpan={tabValue === 5 ? 5 : 6}
                                >
                                  <div className="flex justify-center py-4">
                                    <p className="text-center text-gray-500">
                                      {tabValue === 5
                                        ? "Loading Campaign Contacts..."
                                        : "Loading Chatbot Leads..."}
                                    </p>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ) : rows.length > 0 ? (
                              rows.map((info, i) => {
                                const pageOffset =
                                  ((tabValue === 5
                                    ? socialMediaPage
                                    : chatbotLeadsPage) -
                                    1) *
                                  rowsPerPage;
                                return (
                                  <TableRow
                                    key={info.id || info.enquiryId || i}
                                  >
                                    <TableCell>
                                      {pageOffset + i + 1}
                                    </TableCell>
                                    {tabValue === 5 ? (
                                      <>
                                        <TableCell title={info.name || ""}>
                                          {truncateCellText(info.name || "—")}
                                        </TableCell>
                                        <TableCell title={info.phone || ""}>
                                          {truncateCellText(
                                            info.phone || "—",
                                            20,
                                          )}
                                        </TableCell>
                                        <TableCell>
                                          {info.alreadyExists === true
                                            ? "Yes"
                                            : info.alreadyExists === false
                                              ? "No"
                                              : "—"}
                                        </TableCell>
                                        <TableCell>
                                          {formatLeadDate(info.date)}
                                        </TableCell>
                                      </>
                                    ) : (
                                      <>
                                        <TableCell title={info.name || ""}>
                                          {truncateCellText(info.name || "—")}
                                        </TableCell>
                                        <TableCell title={info.phone || ""}>
                                          {truncateCellText(
                                            info.phone || "—",
                                            18,
                                          )}
                                        </TableCell>
                                        <TableCell
                                          title={info.country || ""}
                                        >
                                          {truncateCellText(
                                            info.country || "—",
                                          )}
                                        </TableCell>
                                        <TableCell
                                          title={String(info.status || "")}
                                        >
                                          {truncateCellText(
                                            info.status || "—",
                                            15,
                                          )}
                                        </TableCell>
                                        <TableCell>
                                          {formatLeadDate(info.date)}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={tabValue === 5 ? 5 : 6}
                                >
                                  <div className="flex justify-center py-4">
                                    <p className="text-center text-gray-500">
                                      {tabValue === 5
                                        ? "No Campaign Contacts Found"
                                        : "No Chatbot Leads Found"}
                                    </p>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </>
                      ) : (
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sr.No.</TableCell>
                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "enquiryId"}
                                  direction={
                                    orderBy === "enquiryId" ? orderDirection : "asc"
                                  }
                                  onClick={() => handleRequestSort("enquiryId")}
                                >
                                  Enquiry IDs
                                </TableSortLabel>
                              </TableCell>
                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "name"}
                                  direction={
                                    orderBy === "name" ? orderDirection : "asc"
                                  }
                                  onClick={() => handleRequestSort("name")}
                                >
                                  Name
                                </TableSortLabel>
                              </TableCell>

                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "country"}
                                  direction={
                                    orderBy === "country" ? orderDirection : "asc"
                                  }
                                  onClick={() => handleRequestSort("country")}
                                >
                                  Country
                                </TableSortLabel>
                              </TableCell>

                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "treatingIn"}
                                  direction={
                                    orderBy === "treatingIn"
                                      ? orderDirection
                                      : "asc"
                                  }
                                  onClick={() => handleRequestSort("treatingIn")}
                                >
                                  Treating In
                                </TableSortLabel>
                              </TableCell>
                              {/* <TableCell>
                            <TableSortLabel
                              active={orderBy === "createdBy"}
                              direction={
                                orderBy === "createdBy" ? orderDirection : "asc"
                              }
                              onClick={() => handleRequestSort("createdBy")}
                            >
                              Created By
                            </TableSortLabel>
                          </TableCell> */}
                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "date"}
                                  direction={
                                    orderBy === "date" ? orderDirection : "asc"
                                  }
                                  onClick={() => handleRequestSort("date")}
                                >
                                  Date / Time
                                </TableSortLabel>
                              </TableCell>
                              <TableCell>
                                <TableSortLabel
                                  active={orderBy === "Enquiry_status"}
                                  direction={
                                    orderBy === "Enquiry_status"
                                      ? orderDirection
                                      : "asc"
                                  }
                                  onClick={() =>
                                    handleRequestSort("Enquiry_status")
                                  }
                                >
                                  Status
                                </TableSortLabel>
                              </TableCell>
                              {/* <TableCell>Status</TableCell> */}
                              <TableCell>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(pdfRowLimit
                              ? rows.slice(0, pdfRowLimit)
                              : rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage,
                              )
                            ).length > 0 ? (
                              (pdfRowLimit
                                ? rows.slice(0, pdfRowLimit)
                                : rows.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage,
                                )
                              ).map((info, i) => {
                                console.log(info);
                                return (
                                  <>
                                    <TableRow
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={info.code}
                                    >
                                      <TableCell>
                                        {pdfRowLimit
                                          ? i + 1
                                          : page * rowsPerPage + i + 1}
                                      </TableCell>
                                      <TableCell>{info.enquiryId}</TableCell>
                                      <TableCell
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) =>
                                          ViewDetail(e, tabValue, info)
                                        }
                                        title={info.name}
                                      >
                                        {truncateCellText(info.name)}
                                      </TableCell>
                                      <TableCell title={info.country}>
                                        {truncateCellText(info.country)}
                                      </TableCell>
                                      <TableCell title={info.treatingIn}>
                                        {truncateCellText(info.treatingIn)}
                                      </TableCell>
                                      {/* <TableCell>{info.createdBy}</TableCell> */}
                                      <TableCell>
                                        {new Date(info.date).toLocaleDateString(
                                          "en-GB",
                                        )}
                                        -
                                        {new Date(info.date).toLocaleTimeString(
                                          "en-GB",
                                          {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          },
                                        )}
                                      </TableCell>

                                      <TableCell>
                                        {info.Enquiry_status === "Confirmed" ? (
                                          // ✅ Only show text
                                          <span style={{ fontWeight: "bold" }}>
                                            Confirm
                                          </span>
                                        ) : (
                                          // ✅ Otherwise show dropdown
                                          <FormControl
                                            sx={{ m: 1, minWidth: 120 }}
                                            size="small"
                                            className="cont-main"
                                          >
                                            <Select
                                              value={
                                                seekerStatus[info.enquiryId]
                                                  ? seekerStatus[info.enquiryId]
                                                  : getEnquiryStatusValue(
                                                      info.Enquiry_status,
                                                    )
                                              }
                                              onChange={(e) => {
                                                if (isReferral) return;
                                                handleChange(
                                                  e,
                                                  info.enquiryId,
                                                  tabValue,
                                                  info,
                                                );
                                              }}
                                              disabled={isReferral}
                                              displayEmpty
                                              className="status-direct"
                                              sx={
                                                isReferral
                                                  ? {
                                                      "&.Mui-disabled": {
                                                        cursor: "not-allowed",
                                                        backgroundColor: "#f9f9f9",
                                                      },
                                                      "& .MuiSelect-select.Mui-disabled": {
                                                        WebkitTextFillColor: "var(--bs-text-color, #333)",
                                                        fontWeight: 600,
                                                        cursor: "not-allowed",
                                                      },
                                                    }
                                                  : {}
                                              }
                                            >
                                              <MenuItem value="0">Pending</MenuItem>
                                              <MenuItem value="1">
                                                Confirm
                                              </MenuItem>
                                              <MenuItem value="2">Hold</MenuItem>
                                              <MenuItem value="3">
                                                Follow-up
                                              </MenuItem>
                                              <MenuItem value="5">Visit 1</MenuItem>
                                              <MenuItem value="6">Visit 2</MenuItem>
                                              <MenuItem value="7">Visa</MenuItem>
                                              <MenuItem value="4">Close</MenuItem>
                                            </Select>
                                          </FormControl>
                                        )}
                                      </TableCell>
                                      <TableCell className="action-icon">
                                        {isReferral ? (
                                          <>
                                            <VisibilityIcon
                                              className="eye-icon"
                                              style={{ cursor: "pointer" }}
                                              titleAccess="View Details"
                                              onClick={(e) =>
                                                ViewDetail(e, tabValue, info)
                                              }
                                            />
                                            <i
                                              className="fa-solid fa-pen-to-square"
                                              title="Edit"
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) =>
                                                tabValue === 1
                                                  ? EditAmbulance(e, info)
                                                  : tabValue === 2
                                                    ? EditAirAmbulance(e, info)
                                                    : tabValue === 3
                                                      ? EditTreatmentEstimate(e, info)
                                                      : EditButton(
                                                          e,
                                                          tabValue === 0
                                                            ? info.enquiryId
                                                            : info.id,
                                                        )
                                              }
                                            ></i>
                                          </>
                                        ) : (
                                          <>
                                            {(tabValue === 0 || tabValue === 1 || tabValue === 2 || tabValue === 3) ? (
                                              <>
                                                <i
                                                  className="fa-solid fa-notes-medical"
                                                  title="Create Notes"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    handleClickOpen2(e, tabValue === 0 ? info.enquiryId : info.id)
                                                  }
                                                ></i>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {/* {tabValue === 0
                                      ? !info?.hasDoctorReview && (
                                          <i
                                            className="fa-solid fa-stethoscope"
                                            onClick={(e) =>
                                              handleClickOpen4(
                                                e,
                                                info.enquiryId,
                                                info,
                                              )
                                            }
                                          ></i>
                                        )
                                      : Object.keys(
                                          info?.raw?.doctor_review || {},
                                        ).length === 0 && (
                                          <i
                                            className="fa-solid fa-stethoscope"
                                            onClick={(e) =>
                                              handleClickOpen4(
                                                e,
                                                info.enquiryId,
                                                info,
                                              )
                                            }
                                          ></i>
                                        )} */}
                                            {/* {(localStorage.getItem("Role") ===
                                      "Admin" ||
                                      localStorage.getItem("Role") ===
                                      "Doctor") &&
                                      (tabValue === 0
                                        ? !info?.hasDoctorReview && (
                                          <i
                                            className="fa-solid fa-stethoscope"
                                            onClick={(e) =>
                                              handleClickOpen4(
                                                e,
                                                info.enquiryId,
                                                info,
                                              )
                                            }
                                          ></i>
                                        )
                                        : Object.keys(
                                          info?.raw?.doctor_review || {},
                                        ).length === 0 && (
                                          <i
                                            className="fa-solid fa-stethoscope"
                                            onClick={(e) =>
                                              handleClickOpen4(
                                                e,
                                                info.enquiryId,
                                                info,
                                              )
                                            }
                                          ></i>
                                        ))} */}
                                            {canDoctorReview && (
                                              <i
                                                className="fa-solid fa-stethoscope"
                                                onClick={(e) =>
                                                  handleClickOpen4(
                                                    e,
                                                    info.enquiryId,
                                                    info,
                                                  )
                                                }
                                              ></i>
                                            )}
                                            {info?.hasAppointment === true ? (
                                              ""
                                            ) : (
                                              <i
                                                className="fa-solid fa-calendar-plus"
                                                title="Add Appointment"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleOpenAppointment(info)
                                                }
                                              ></i>
                                            )}
                                            <VisibilityIcon
                                              className="eye-icon"
                                              onClick={(e) =>
                                                ViewDetail(e, tabValue, info)
                                              }
                                            />
                                            {tabValue === 0 ? (
                                              <>
                                                {allowEdit && (
                                                  <i
                                                    className="fa-solid fa-pen-to-square"
                                                    onClick={(e) =>
                                                      EditButton(e, info.enquiryId)
                                                    }
                                                  ></i>
                                                )}
                                                {allowDelete && (
                                                    <i
                                                      className="fa-solid fa-trash"
                                                      onClick={() => handledelete(info)}
                                                    ></i>
                                                  )}
                                              </>
                                            ) : (
                                              <>
                                                {allowEdit &&
                                                  (tabValue === 1 ||
                                                  tabValue === 2 ||
                                                  tabValue === 3) && (
                                                  <i
                                                    className="fa-solid fa-pen-to-square"
                                                    title="Edit"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={(e) =>
                                                      tabValue === 1
                                                        ? EditAmbulance(e, info)
                                                        : tabValue === 2
                                                          ? EditAirAmbulance(e, info)
                                                          : EditTreatmentEstimate(
                                                              e,
                                                              info,
                                                            )
                                                    }
                                                  ></i>
                                                )}
                                                {allowDelete && (
                                                <i
                                                  className="fa-solid fa-trash"
                                                  onClick={() =>
                                                    handleDeleteExternal(info)
                                                  }
                                                ></i>
                                                )}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell colSpan={11}>
                                  <div className="flex justify-center py-4">
                                    <p className="text-center text-gray-500">
                                      No Data Found
                                    </p>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </>
                      )}
                    </Table>
                    {!pdfRowLimit && (
                      <Stack spacing={2}>
                        <Pagination
                          className="page-nation"
                          count={
                            tabValue === 5
                              ? socialMediaTotalPages
                              : tabValue === 6
                                ? chatbotLeadsTotalPages
                                : Math.ceil(rows.length / rowsPerPage) || 1
                          }
                          page={
                            tabValue === 5
                              ? socialMediaPage
                              : tabValue === 6
                                ? chatbotLeadsPage
                                : page + 1
                          }
                          onChange={(event, value) => {
                            if (tabValue === 5) {
                              setSocialMediaPage(value);
                            } else if (tabValue === 6) {
                              setChatbotLeadsPage(value);
                            } else {
                              setPage(value - 1);
                            }
                          }}
                          color="primary"
                        />
                      </Stack>
                    )}
                  </TableContainer>
                </div>
              </div>
            </div>
            <div
              id="delete_appointment"
              className="modal fade delete-modal"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <img
                      src="assets/img/sent.png"
                      alt=""
                      width="50"
                      height="46"
                    />
                    <h3>Are you sure want to delete this Appointment?</h3>
                    <div className="m-t-20">
                      {" "}
                      <a
                        href="#"
                        className="btn btn-white"
                        data-dismiss="modal"
                      >
                        Close
                      </a>
                      <button type="submit" className="btn btn-danger">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open3}
          onClose={handleClose3}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Import Excel File</h6>
            </div>
            <div className="cross-icon" onClick={handleClose3}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="Date / Time-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Choose File<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="fileSelect"
                      accept=".xlsx, .xls, .csv"
                      onChange={(event) => {
                        const file = event.target.files[0];
                        console.log("Selected file:", file);
                        setSelectedImage(file);
                      }}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={busyKey === "import"}
                      onClick={(e) => handleImportFile(e)}
                    >
                      {busyKey === "import" ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          open={openAppointment}
          onClose={handleCloseAppointment}
          fullWidth
          maxWidth="sm"
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Appointment</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseAppointment}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="view-table-detail">
            <Box className="contact-form">
              <div className="field-set mb-2">
                <FormControl fullWidth size="small">
                  <label>Select Hospital</label>
                  <Select
                    value={appointmentData.hospital_id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      const selectedHospital = hospitalList.find(
                        (item) => item.id === selectedId,
                      );

                      setAppointmentData((prev) => ({
                        ...prev,
                        hospital_id: selectedId,
                        hospitalName: selectedHospital?.name || "",
                        hospital_email: selectedHospital?.email || "",
                      }));
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250,
                        },
                      },
                    }}
                  >
                    {hospitalList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="field-set">
                <label>Health Issue</label>
                <input
                  type="text"
                  name="health_issue"
                  className="form-control"
                  value={appointmentData.health_issue}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>
                  Date<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="appointment_Date"
                  className="form-control"
                  value={appointmentData.appointment_Date}
                  onChange={handleAppointmentChange}
                  min={todayDateInput()}
                />
              </div>
              <div className="field-set">
                <label>Time</label>
                <span className="text-danger">*</span>
                <input
                  type="time"
                  name="appointment_Time"
                  className="form-control"
                  value={appointmentData.appointment_Time}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>Notes</label>
                <span className="text-danger">*</span>
                <textarea
                  name="Notes"
                  className="form-control"
                  value={appointmentData.Notes}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>
                  Upload Reports / Documents{" "}
          
                </label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={(e) => {
                    const files = Array.from(e.target.files);
                    setImages(files);
                  }}
                />
                {images.length > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    {images.map((file, index) => (
                      <div key={index} style={{ fontSize: "12px" }}>
                        📄 {file.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <DialogActions className="submit-main">
                <Button
                  variant="contained"
                  disabled={busyKey === "appointment"}
                  onClick={handleSubmitAppointment}
                >
                  {busyKey === "appointment" ? "Submitting..." : "Submit"}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open9}
          onClose={handleClose2wew}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Hospitals</h6>
            </div>
            <div className="cross-icon" onClick={handleClose2wew}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form">
                  <div className="col-sm-12">
                    <div className="field-set">
                      <label>
                        Select Hospital<span className="text-danger">*</span>
                      </label>
                      <Autocomplete
                        multiple
                        options={
                          hospital && hospital.length > 0
                            ? hospital.map((h) => h.name)
                            : []
                        }
                        value={report.hospital || []}
                        onChange={handleHospitalChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search & Select Hospital"
                            variant="outlined"
                            size="small"
                          />
                        )}
                      />
                    </div>
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={busyKey === "notes"}
                      onClick={handleNotesdata}
                    >
                      {busyKey === "notes" ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open2}
          onClose={handleClose2}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Create Notes</h6>
            </div>
            <div className="cross-icon" onClick={handleClose2}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form">
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="w3review"
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => setNote(e.target.value)}
                      value={note}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !note ? "Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>
                      Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="date"
                      placeholder="Date"
                      className="form-control"
                      onChange={(e) => setDate(e.target.value)}
                      value={date}
                      min={todayDateInput()}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !date ? "Please Enter Your  date" : ""}
                    </span>
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={busyKey === "notes"}
                      onClick={handleNotesdata}
                    >
                      {busyKey === "notes" ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog fullWidth maxWidth="sm" open={open4} onClose={handleClose4}>
          <div className="main-card-header d-flex justify-content-between align-items-center px-3 py-2">
            <div className="note-hd">
              <h6>Doctor Review</h6>
            </div>
            <div className="cross-icon" onClick={handleClose4}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              <Box>
                <form id="contact-form">
                  <div className="field-set">
                    <label>
                      Subject<span className="text-danger">*</span>
                    </label>
                    <input
                      id=""
                      name="Title"
                      onChange={handleRecommendTitle}
                      className="form-control"
                      value={Title}
                      placeholder="Subject"
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Review Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="w3review"
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      placeholder="Review"
                      onChange={handleNoteChange}
                      value={note}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !note ? "Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>Upload Images</label>
                    <input
                      type="file"
                      className="form-control"
                      multiple
                      onChange={handleImageChange}
                      name="upload_image"
                      id=""
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Recommendations<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id=""
                      name="recommend"
                      rows="4"
                      cols="50"
                      onChange={handleRecommendChange}
                      className="form-control"
                      value={recommend}
                      placeholder="Recommendations"
                    />
                  </div>

                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={busyKey === "review"}
                      onClick={handleNotesdataqw}
                    >
                      {busyKey === "review" ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          open={leadDetailOpen}
          onClose={handleCloseLeadDetail}
          fullWidth
          maxWidth="sm"
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>
                {tabValue === 5
                  ? "Campaign Contact Detail"
                  : "Chatbot Lead Detail"}
              </h6>
            </div>
            <div className="cross-icon" onClick={handleCloseLeadDetail}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="view-table-detail">
            {selectedLead ? (
              <Box className="contact-form">
                <div className="row gx-3">
                  {(tabValue === 5
                    ? [
                        ["Name", selectedLead.name],
                        ["Phone", selectedLead.phone],
                        ["Country Code", selectedLead.countryCode],
                        ["Channel", selectedLead.channelType],
                        ["Source", selectedLead.source],
                        ["Source URL", selectedLead.sourceUrl],
                        ["Source ID", selectedLead.sourceId],
                        [
                          "Already Exists",
                          selectedLead.alreadyExists === true
                            ? "Yes"
                            : selectedLead.alreadyExists === false
                              ? "No"
                              : null,
                        ],
                        [
                          "WhatsApp Opted In",
                          selectedLead.whatsappOptedIn === true
                            ? "Yes"
                            : selectedLead.whatsappOptedIn === false
                              ? "No"
                              : null,
                        ],
                        ["Date", formatLeadDate(selectedLead.date)],
                        ["Contact ID", selectedLead.id],
                      ]
                    : [
                        ["Lead ID", selectedLead.enquiryId || selectedLead.id],
                        ["Name", selectedLead.name],
                        ["Email", selectedLead.email],
                        ["Phone", selectedLead.phone],
                        ["Country", selectedLead.country],
                        ["Treating In", selectedLead.treatingIn],
                        ["Source", selectedLead.source],
                        ["Status", selectedLead.status],
                        ["Date", formatLeadDate(selectedLead.date)],
                        ["Message", selectedLead.message],
                      ]
                  ).map(([label, value]) =>
                    value ? (
                      <div className="col-md-6 mb-2" key={label}>
                        <strong>{label}:</strong>
                        <div>{String(value)}</div>
                      </div>
                    ) : null,
                  )}
                </div>
                {selectedLead.raw && (
                  <div className="mt-3">
                    <strong>All Fields</strong>
                    <pre
                      style={{
                        maxHeight: 220,
                        overflow: "auto",
                        background: "#f7f7f7",
                        padding: 12,
                        borderRadius: 6,
                        fontSize: 12,
                      }}
                    >
                      {JSON.stringify(selectedLead.raw, null, 2)}
                    </pre>
                  </div>
                )}
              </Box>
            ) : null}
          </DialogContent>
          <DialogActions className="submit-main">
            <Button variant="contained" onClick={handleCloseLeadDetail}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <ToastContainer />
    </>
  );
}